module.exports = __webpack_public_path__ + "img/pro_three_2.b8f13016.jpg";